export const AUDIT_STATUS = {
  REQUIRES_AUDIT: "REQUIRES_AUDIT",
  AUDITED: "AUDITED",
};
